var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConcludeDefaultIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_652_1023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 4.26599C7.73544 4.26599 4.26637 7.73506 4.26637 11.9991C4.26637 16.2631 7.73544 19.7322 11.9995 19.7322C16.2894 19.7322 19.7794 16.2631 19.7794 11.9991C19.7794 7.73506 16.2894 4.26599 11.9995 4.26599ZM12.7025 18.2876V16.9202H11.2965V18.287C8.36826 17.9618 6.03688 15.6303 5.71167 12.7022H7.0784V11.2961H5.71167C6.03688 8.36792 8.36826 6.03655 11.2965 5.71133V7.07806H12.7025V5.71072C15.6549 6.03378 18.0061 8.36619 18.3339 11.2961H16.9674V12.6975H18.3339C18.006 15.6274 15.6548 17.9645 12.7025 18.2876Z",
    fill: "#D90F81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7025 11.2961V8.48404H11.2964V12.7021H14.1085V11.2961H12.7025Z",
    fill: "#D90F81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0711 4.16409L22.9447 4.26501L23.0204 2.86101L18.5001 2.6175L18.7656 6.84187L20.1688 6.75365L20.0683 5.15413C23.5953 9.2743 23.4464 15.5121 19.5029 19.4557C15.3084 23.65 8.73729 23.65 4.54292 19.4557C0.36168 15.2744 0.36168 8.7238 4.54292 4.5426C6.56487 2.52066 9.21302 1.40714 11.9995 1.40714V0.00112915C8.87318 0.00112915 5.83573 1.26136 3.54871 3.54843C-1.18088 8.27797 -1.185 15.7163 3.54871 20.4499C8.27899 25.1803 15.7634 25.1836 20.497 20.4499C24.9771 15.97 25.1505 8.84886 21.0711 4.16409Z",
    fill: "#D90F81"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_652_1023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcludeDefaultIc);
export default __webpack_public_path__ + "static/media/conclude-default-ic.392d2cab2f18bcae1be026f23c1b6763.svg";
export { ForwardRef as ReactComponent };